/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { PipelineCandidateSequenceInfo } from './pipelineCandidateSequenceInfo';
import type { ProfileJobItemLastContactChannel } from './profileJobItemLastContactChannel';

export interface ProfileJobItem {
  job_candidate_id: string;
  job_id: string;
  job_title: string;
  stage_id?: string | null;
  stage_name?: string | null;
  stage_color?: string | null;
  added_at: string;
  origin: string;
  project_id?: string | null;
  project_title?: string | null;
  project_cover_image_url?: string | null;
  job_status?: string | null;
  job_is_archived?: boolean;
  job_manager_id?: string | null;
  job_manager_name?: string | null;
  sequences?: PipelineCandidateSequenceInfo[];
  last_contacted_at?: string | null;
  last_contact_channel?: ProfileJobItemLastContactChannel;
}
